import { render } from "./Competences.vue?vue&type=template&id=168baba0"
import script from "./Competences.vue?vue&type=script&lang=js"
export * from "./Competences.vue?vue&type=script&lang=js"

import "./Competences.vue?vue&type=style&index=0&id=168baba0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__